import React, { Component } from "react";
import "./TicketInputComponent.css";
import history from "../../history";
import ViewProfile from "../ViewProfile";
import SidebarComponent from "../SidebarComponent/SidebarComponent";
import axios from "axios";
import TicketDetailsEditor from "./TicketDetailsEditor";
import { baseUrl } from "../../config";

class MeeshoComponent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      ticketId: "",
      customerId: "",
      customerDetails: null,
      isLoading: false,
    };
  }

  handleLogout() {
    localStorage.removeItem("token");
    document.querySelector(".modal-backdrop").style.display = "none";
    history.push("/");
  }

  handleBackClick = () => {
    this.setState({
      customerDetails: null, // Reset customer details
    });
  };

  handleChange = (e) => {
    const { name, value } = e.target;

    // Validate based on the name of the field
    if (name === "ticketId") {
      // Only allow numbers for ticket ID
      if (/^[0-9]*$/.test(value)) {
        this.setState({ [name]: value });
      }
    }
  };
  handleSubmit = async () => {
    const { ticketId, customerId } = this.state;
    let token = localStorage.getItem("token");
    if (!ticketId || !customerId) {
      alert("Please enter both Ticket ID and Customer ID");
      return;
    }

    this.setState({ isLoading: true });

    try {
      const response = await axios.post(baseUrl+"-complaint/meesho/ticket/details",
    {
      ticket_id: ticketId,
      customer_id: customerId,
    },
    {
      headers: {
        'x-access-token': token, 
      },
    }
  );

      const data = response.data.data;

      this.setState({
        isLoading: false,
        customerDetails: data.customer_details || {},
        complaintDetails: data.complaint_details,
      });

      console.log("Fetched ticket details:", data);
    } catch (error) {
      this.setState({ isLoading: false });

      if (error.response) {
        const errorMessage = error.response.data.errors
          ? error.response.data.errors.message
          : "Unknown error";
        const errorStatus = error.response.data.errors
          ? error.response.data.errors.statusCode
          : "Unknown status";

        if (errorStatus === 401) {
          alert("Session expired. Please log in again.");
          localStorage.removeItem("token");
          history.push("/");
          return;
        }
        // Alert the user with the API error message and status code
        alert(`API Error: ${errorMessage} (Status Code: ${errorStatus})`);
      }
      // Case 2: API No Response (Request made, but no response)
      else if (error.request) {
        console.error("API No Response:", error.request);
        alert("No response from the server. Please try again later.");
      } else {
        // Handle any other errors, like issues setting up the request
        console.error("General Error:", error.message);
        alert(`Error: ${error.message}`);
      }
    }
  };

  render() {

    return (
      <div>
        {window.innerWidth > 600 && <SidebarComponent sideProp={"DB"} />}
        <ViewProfile />

        <div className="content-dashboard">
          <div className="content-title">
            <h3>Meesho Ticket Update</h3>
          </div>

          {!this.state.customerDetails ? (
            <div className="form-wrapper">
              <div className="form-group">
                <label>Ticket ID</label>
                <input
                  type="text"
                  className="form-control"
                  name="ticketId" 
                  value={this.state.ticketId}
                  onChange={this.handleChange} // Use handleChange
                />
              </div>

              <div className="form-group">
                <label>Customer ID</label>
                <input
                  type="text"
                  className="form-control"
                  value={this.state.customerId}
                  onChange={(e) =>
                    this.setState({ customerId: e.target.value })
                  }
                />
              </div>

              <button className="submit-btn" onClick={this.handleSubmit}>
                Submit
              </button>
            </div>
          ) : (
            <TicketDetailsEditor
              customerDetails={this.state.customerDetails}
              complaintDetails={this.state.complaintDetails}
              backToForm={this.handleBackClick} // Passing backToForm function
              onChange={this.handleCustomerChange}
            />
          )}
        </div>
      </div>
    );
  }
}

export default MeeshoComponent;
